import readingPaneStore from '../store/Store';
import { action } from 'satcheljs/lib/legacy';
export default action('setItemPrintPaneViewState')(function setItemPrintPaneViewState(viewState) {
    readingPaneStore.itemPrintPaneViewState = viewState;
});
//# sourceMappingURL=setItemPrintPaneViewState.js.map